import {WebConferenceTypes} from "@share/web-conferences/enums/WebConferenceTypes";

/**
 * Returns conference type
 * if schema is a meeting schema then WebConferenceTypes.Meeting
 * else WebConferenceTypes.Webinar
 * @param schemaId
 */
export const conferenceType = (schemaId: string): WebConferenceTypes => {
  return  schemaId == 'Meetings' ? WebConferenceTypes.Meeting : WebConferenceTypes.Webinar;
};
